export default __webpack_public_path__ + "static/media/profile-img.6994fbf6.png";